import { Link } from "react-router-dom";

const articles = [
  {
    slug: "latest-access-2026",
    title: "禁漫天堂2026年最新访问入口汇总（持续更新）",
    excerpt: "本文汇总禁漫天堂所有当前可用的访问入口与镜像站点，确保用户能够稳定、快速地访问平台全部功能。包含PC端、移动端与APP端访问方式。",
    date: "2026-08-08",
    category: "使用教程",
    isNew: true,
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20illustration%20of%20digital%20access%20and%20portal%20navigation%20concept%2C%20soft%20coral%20cream%20color%20palette%2C%20clean%20simple%20composition%2C%20modern%20digital%20art%20style%2C%20no%20text&width=800&height=500&seq=feat-01&orientation=landscape",
  },
  {
    slug: "register-login-guide",
    title: "禁漫天堂新用户注册与登录完整教程",
    excerpt: "手把手教你完成禁漫天堂的新用户注册流程，包括邮箱注册、手机号绑定、第三方账号登录等多种方式，以及常见登录问题解决方案。",
    date: "2026-08-06",
    category: "使用教程",
    isNew: true,
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20illustration%20of%20user%20registration%20and%20login%20process%20on%20a%20digital%20platform%2C%20soft%20coral%20cream%20colors%2C%20clean%20minimalist%20style%2C%20modern%20UI%20aesthetic%2C%20no%20text&width=800&height=500&seq=feat-02&orientation=landscape",
  },
  {
    slug: "content-category-overview",
    title: "禁漫天堂内容分类完整导览：找到你喜欢的漫画",
    excerpt: "详细介绍禁漫天堂的内容分类体系，帮助你快速定位感兴趣的热血、恋爱、奇幻、搞笑、悬疑、科幻等各类型漫画作品。",
    date: "2026-08-04",
    category: "内容导览",
    isNew: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20abstract%20illustration%20of%20content%20categories%20and%20organization%2C%20grid%20layout%20concept%2C%20soft%20coral%20cream%20palette%2C%20minimalist%20modern%20design%2C%20no%20text&width=800&height=500&seq=feat-03&orientation=landscape",
  },
  {
    slug: "mirror-site-guide",
    title: "禁漫天堂镜像站使用指南与注意事项",
    excerpt: "全面解析禁漫天堂镜像站的使用方法、访问技巧以及安全注意事项，确保你的阅读体验顺畅无阻且数据安全。",
    date: "2026-08-02",
    category: "使用教程",
    isNew: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20illustration%20of%20mirror%20website%20and%20network%20security%20concept%2C%20soft%20coral%20cream%20tones%2C%20clean%20minimalist%20digital%20art%2C%20no%20text&width=800&height=500&seq=feat-04&orientation=landscape",
  },
  {
    slug: "mobile-app-guide",
    title: "禁漫天堂移动端APP下载安装全攻略",
    excerpt: "详细介绍禁漫天堂移动端APP的下载渠道、安装步骤、功能亮点以及常见问题处理，让你随时随地畅享漫画阅读。",
    date: "2026-07-30",
    category: "使用教程",
    isNew: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20illustration%20of%20mobile%20app%20download%20and%20smartphone%20usage%2C%20soft%20coral%20cream%20palette%2C%20clean%20minimalist%20design%2C%20no%20text&width=800&height=500&seq=feat-05&orientation=landscape",
  },
  {
    slug: "reading-experience-optimize",
    title: "提升禁漫天堂阅读体验的10个实用技巧",
    excerpt: "分享10个提升漫画阅读体验的实用技巧，包括阅读模式选择、书签管理、下载设置、夜间模式等功能的深度使用。",
    date: "2026-07-28",
    category: "使用教程",
    isNew: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20illustration%20of%20digital%20reading%20experience%20optimization%2C%20cozy%20reading%20atmosphere%2C%20soft%20coral%20cream%20colors%2C%20modern%20minimalist%20art%2C%20no%20text&width=800&height=500&seq=feat-06&orientation=landscape",
  },
];

export default function HotArticles() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-center justify-between mb-12 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              热门使用教程
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              精选禁漫天堂最实用的使用指南与操作教程
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-accent-300/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-background-50/90 text-foreground-700 rounded-md text-xs font-medium">
                    {article.category}
                  </span>
                </div>
                {article.isNew && (
                  <div className="absolute top-3 right-3">
                    <span className="px-2 py-0.5 bg-accent-500 text-background-50 rounded-md text-xs font-medium">
                      新
                    </span>
                  </div>
                )}
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1 text-accent-600 font-medium">
                    阅读全文
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}